import {
  IIntegrationCustomer,
  IIntegrationVendor
} from "@wingspanhq/integrations/dist/lib/interfaces";
import { getIntegrationUserSelectLabel } from "./getIntegrationUserSelectLabel";

const compare = (a: string = "", b: string = "") =>
  a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase());

export const getSortedAndGroupedQuickbooksUserList = <
  User extends IIntegrationCustomer | IIntegrationVendor
>(
  users: User[]
): User[] => [
  ...users.sort((a, b) =>
    compare(getIntegrationUserSelectLabel(a), getIntegrationUserSelectLabel(b))
  )
];
